export function createSecurityRequest(apiBaseUrl) {
  const base = apiBaseUrl ? String(apiBaseUrl).replace(/\/$/, '') : '';
  return function request(path, options = {}) {
    return fetch(`${base}${path}`, options);
  };
}
